(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("shacl"), require("rdflib"));
	else if(typeof define === 'function' && define.amd)
		define([, ], factory);
	else if(typeof exports === 'object')
		exports["VueShaclForm"] = factory(require("shacl"), require("rdflib"));
	else
		root["VueShaclForm"] = factory(root["SHACLValidator"], root["$rdf"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__5d49__, __WEBPACK_EXTERNAL_MODULE_fd3a__) {
return 